import { Dispatch } from "redux"
import AxiosControl from '../../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getReceipts = (page: number | null = null, limit: number | null = null, search: Object = '', sort: any = null) => async (dispatch: Dispatch) => {
    dispatch({ type: 'RECEIPT_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/receipt/getall/', { page, limit, search, sort }, {
            headers: { auth: localStorage.getItem('jwt'), ente: localStorage.getItem('enteId') }
        })
        if (status === 200) {
            dispatch({
                type: 'RECEIPT_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'RECEIPT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}

export const getReceiptsByPolicy = (policyId: string, page: number | null = null, limit: number | null = null) => async (dispatch: Dispatch) => {
    dispatch({ type: 'RECEIPT_LOADING' })
    try {
        const { data, status } = await Axios.get(`/api/receipt/getAllByPolicy/${policyId}`,
            {
                headers: { auth: localStorage.getItem('jwt') }
            }
        )
        if (status === 200) {
            dispatch({
                type: 'RECEIPT_GETALL_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'RECEIPT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}


export const getForSelect = () => async (dispatch: Dispatch) => {
    dispatch({ type: 'RECEIPT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/receipt/getforselect/', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RECEIPT_GETALLFORSELECT_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'RECEIPT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}

export const getReceipt = (receipt: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'RECEIPT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/receipt/get/' + receipt, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RECEIPT_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'RECEIPT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}

export const readReceipt = (idReceipt: string) => async (dispatch: Dispatch) => {
    dispatch({
        type: 'RECEIPTDATA_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/receipt/readReceipt/' + idReceipt, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 304) {
            dispatch({
                type: 'RECEIPTDATA_GET_SUCCESS',
                payload: data
            })
        } else {
            dispatch({
                type: 'RECEIPTDATA_NOT_LOADING'
            })
        }
    } catch (error) {
        dispatch({
            type: 'RECEIPTDATA_NOT_LOADING'
        })
    }
}

export const editReceipt = (receipt: any, id?: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'RECEIPT_LOADING' })
    try {
        const { data, status } = await Axios.put('/api/receipt/edit/' + id, receipt, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'RECEIPT_EDIT_SUCCESS',
                payload: { message: data.message, id, updatedReceipt: receipt }
            })
        } else {
            dispatch({ type: 'RECEIPT_NOT_LOADING' })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}

export const getPaymentMethods = () => async (dispatch: Dispatch) => {
    const { data, status } = await Axios.get('/api/receipt/getallpaymentmethods/', {
        headers: { auth: localStorage.getItem('jwt') }
    })
    if (status === 200) {
        dispatch({
            type: 'PAYMENTMETHODS_GET_SUCCESS',
            payload: data
        })
    }
}

export const importPaymentMethodFromEbroker = () => async (dispatch: Dispatch) => {
    dispatch({
        type: 'PAYMENTMETHODS_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/receipt/getallmethodsbroker/', {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200) {
            dispatch({
                type: 'PAYMENTMETHODS_IMPORT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'PAYMENTMETHODS_NOT_LOADING'
        })
    }
}

export const verifyCode = (code: string) => async (dispatch: Dispatch) => {
    dispatch({ type: 'RECEIPT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/receipt/verifycode/' + code, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'RECEIPT_VERIFY_CODE_SUCCESS',
                payload: data
            })
        } else {
            dispatch({ type: 'RECEIPT_VERIFY_CODE_ERROR', payload: { message: status === 404 ? 'invalidCode' : 'serverError' } })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}

export const getReceiptPaymentFormParams = (receiptId: string, importeTotal: number) => async (dispatch: Dispatch) => {
    dispatch({ type: 'RECEIPT_LOADING' })
    try {
        const { data, status } = await Axios.post('/api/payment/receipt/createPaymentForm/' + receiptId,
            { importeTotal },
            { headers: { auth: localStorage.getItem('jwt') } }
        )
        if (status === 200) {
            dispatch({
                type: 'RECEIPT_GET_PAYMENT_FORM_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}

export const checkPaidReceipts = (receiptIds: string[]) => async (dispatch: Dispatch) => {
    try {
        const { data, status } = await Axios.post('/api/payment/checkpaid', { receiptIds })
        if (status === 200) {
            dispatch({
                type: 'RECEIPT_CHECK_PAID_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({ type: 'RECEIPT_NOT_LOADING' })
    }
}